<div class="confirm-delete-rule evir-font-default">
  <div mat-dialog-content>
    <p>Are you sure you want to delete the selected rules?</p>
  </div>
  <div mat-dialog-actions align="center">
    <app-action-button class="no-btn" cdkFocusInitial title="No" (buttonClicked)="dialogRef.close()"></app-action-button>
    <app-action-button title="Yes" (buttonClicked)="confirmDelete()"></app-action-button>

  </div>
</div>

<ng-template #deleteRuleError>
  <div>
    <p></p>
  </div>
</ng-template>
